import { useState } from 'react'
import { Select } from 'antd'
{ Option } = Select

export default SelectInput = ({
  form
  item
  label
  type
  options
  config
  formItemRules
}) ->

  [value, setValue] = useState(undefined)

  <Select
    value={form.getFieldValue(item)}
    onChange={(value) ->
      form.setFieldsValue({ [item]: value }) if form
    }
  >
    { options.map((option)->
      <Option
        disabled={option.disabled or false}
        key={option.value or option}
        value={option.value or option}
      >
        { option.label or option }
      </Option>
    )}
  </Select>
